module.exports = __webpack_public_path__ + "img/step-11.e0d27100.jpg";